// extracted by mini-css-extract-plugin
export default {"lastblog":"styles_lastblog__Rvfg4","mbview":"styles_mbview__KWMSG"};